import React from 'react';

const StatusBadge = ({ status }) => {

  // Map both 'confirmed' and 'completed' to the same config
  const statusKey = (status || '').toLowerCase() === 'confirmed' ? 'completed' : (status || '').toLowerCase();
  const statusConfig = {
    completed: {
      bgColor: '#83DD7A',
      textColor: '#4F555D',
      label: 'Completed',
    },
    pending: {
      bgColor: '#FFD466',
      textColor: '#4F555D',
      label: 'Pending',
    },
    error: {
      bgColor: '#FF6666',
      textColor: '#4F555D',
      label: 'Error',
    },
    requested: {
      bgColor: '#A0C4FF',
      textColor: '#4F555D',
      label: 'Requested',
    },
    processing: {
      bgColor: '#A0C4FF',
      textColor: '#4F555D',
      label: 'Processing',
    },
  };

  const config = statusConfig[statusKey] || statusConfig.pending;

  return (
    <span
      className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
      style={{
        backgroundColor: config.bgColor,
        color: config.textColor,
      }}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
